module.exports = __webpack_public_path__ + "media/images/icons/wrench-c23a691d0c461798c0d42f8d35f84eb1.svg";